// extracted by mini-css-extract-plugin
module.exports = {"coupon":"Coupon_coupon__ac7Cw","rules_pop":"Coupon_rules_pop__8eD86","couponModal":"Coupon_couponModal__WTHZA"};